<div class="header">
  <div class="row" style="margin-right: 0px !important">
    <div class="col-md">
      <h3>จำนวนเอกสารดิจิทัล (รายเดือน)</h3>
    </div>
    <!--<div class="col-6 col-md-2">-->
    <!--<div class="dropdown-label-group">-->
    <!--<p-dropdown-->
    <!--class="dv-dropdown"-->
    <!--selectId="company"-->
    <!--[options]="company"-->
    <!--[(ngModel)]="selectedCompany"-->
    <!--[autoDisplayFirst]="false"-->
    <!--placeholder="บริษัท"-->
    <!--&gt;-->
    <!--</p-dropdown>-->
    <!--<label for="company">บริษัท</label>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="col-6 col-md-2">-->
    <!--<div class="dropdown-label-group">-->
    <!--<p-dropdown-->
    <!--class="dv-dropdown"-->
    <!--selectId="companyBusiness"-->
    <!--[options]="homeproGroup"-->
    <!--[(ngModel)]="selectedHomeproGroup"-->
    <!--[autoDisplayFirst]="false"-->
    <!--placeholder="ประเภทธุรกิจ"-->
    <!--&gt;-->
    <!--</p-dropdown>-->
    <!--<label for="companyBusiness">ประเภทธุรกิจ</label>-->
    <!--</div>-->
    <!--</div>-->
    <div class="row" style="margin-right: 0px !important">
      <!--<div class="dropdown-label-group">-->
      <div class="company-dropdown">
        <p-dropdown class="dv-dropdown" selectId="company" [options]="company" [(ngModel)]="selectedCompany"
          [autoDisplayFirst]="false" placeholder="บริษัท" (onChange)="loadMonthlyData()">
        </p-dropdown>
      </div>

      <div class="year-dropdown">
        <p-dropdown class="dv-dropdown" selectId="year" [options]="yearList" [(ngModel)]="selectedYear"
          [autoDisplayFirst]="false" placeholder="ปี" (onChange)="loadMonthlyData()">
        </p-dropdown>
      </div>
      <!--<label for="year">ปี</label>-->
      <!--</div>-->
    </div>
  </div>
</div>

<div class="box-parent scrollable" style="height: calc(100vh - 2.25rem - 150px);">
  <canvas id="signing-counter-bar-chart">{{ charts_signing_counter_bar_stacked }}</canvas>
</div>

<div>
    <app-dashboard-sms></app-dashboard-sms>
</div>

<div class="mt-5">
  <h3>แผนภาพแสดงการดาวน์โหลดเอกสาร (รายเดือน)</h3>
  <div class="mt-3">
    <app-dashboard-download-stat></app-dashboard-download-stat>
  </div>
</div>




// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-list/dashboard-list.component.html